import { render } from "./PaymentChoice.vue?vue&type=template&id=8b9740e2"
import script from "./PaymentChoice.vue?vue&type=script&lang=js"
export * from "./PaymentChoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__